import {type RouteRecordRaw} from 'vue-router';
import {redirectToPHPComponent} from '../default';
import accountStatement from './account-statement';
import agent from './agent';
import contract from './contract';
import credit from './credit';
import entry from './entry';
import invoice from './invoice';
import invoiceChange from './invoice-change';
import invoicingParty from './invoicing-party';
import paymentMethod from './payment-method';
import period from './period';
import statistic from './statistic';
import termination from './termination';

let meta: MetaData = {
    module: 'customer',
};

let routes: RouteRecordRaw[] = [
    {
        name: 'customer-index',
        path: '/customer',
        meta,
        component: redirectToPHPComponent,
    },
];

export default routes.concat(accountStatement, agent, contract, credit, entry, invoice, invoiceChange, invoicingParty, paymentMethod, period, statistic, termination);